import { Inject, Injectable } from "@angular/core";
import { CORE_KIT_CONFIG_TOKEN, CoreKitConfig } from "core-kit";

export enum LogLevel {
  Debug = 0,
  Info = 1,
  Warn = 2,
  Error = 3,
  None = 4
}

@Injectable({
  providedIn: "root"
})
export class LoggerService {
  constructor(@Inject(CORE_KIT_CONFIG_TOKEN) private config: CoreKitConfig) {}

  /**
   * @deprecated Use debug(), info(), warn(), or error() instead for proper log level control
   */
  log(message: string, value: any = null): void {
    if (!this.config.isProduction) {
      if (value) {
        console.log(message, value);
      } else {
        console.log(message);
      }
    }
  }

  debug(message: string, context?: string, data?: any): void {
    this.logWithLevel(LogLevel.Debug, message, context, data);
  }

  info(message: string, context?: string, data?: any): void {
    this.logWithLevel(LogLevel.Info, message, context, data);
  }

  warn(message: string, context?: string, data?: any): void {
    this.logWithLevel(LogLevel.Warn, message, context, data);
  }

  error(message: string, context?: string, data?: any): void {
    this.logWithLevel(LogLevel.Error, message, context, data);
  }

  private logWithLevel(level: LogLevel, message: string, context?: string, data?: any): void {
    if (this.config.isProduction && level < LogLevel.Warn) {
      return;
    }

    const now = new Date();
    const timestamp = `${now.toISOString()} (${this.formatTimezoneOffset(now)})`;
    const prefix = context ? `[${context} ${timestamp}]` : `[${timestamp}]`;
    const logMessage = `${prefix} ${message}`;

    switch (level) {
      case LogLevel.Debug:
        data !== undefined ? console.debug(logMessage, data) : console.debug(logMessage);
        break;
      case LogLevel.Info:
        data !== undefined ? console.log(logMessage, data) : console.log(logMessage);
        break;
      case LogLevel.Warn:
        data !== undefined ? console.warn(logMessage, data) : console.warn(logMessage);
        break;
      case LogLevel.Error:
        data !== undefined ? console.error(logMessage, data) : console.error(logMessage);
        break;
    }
  }

  private formatTimezoneOffset(date: Date): string {
    const offset = -date.getTimezoneOffset();
    const hours = Math.floor(Math.abs(offset) / 60);
    const minutes = Math.abs(offset) % 60;
    const sign = offset >= 0 ? "+" : "-";
    return `UTC${sign}${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  }
}
